import MarkdownRender from "../components/common/MarkdownRender";
import { TabNoData } from "../components/common/NoData";
import NoTextNavBackground from "../components/common/NoTextNavBackground";
import HeroSlider from "../components/common/slider/HeroSlider";

import TrophyDataCard from "../components/elements/trophies/trophyDataCard";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kClubTrophiesURL } from "../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../utils/constants/names";
import { ONE_MONTH_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import { TROPHIES_URL } from "../utils/constants/websiteUrls";
import { customStaticSeoConfig } from "../utils/helpers/helpers";

const Trophies = ({ kotokoTrophies }) => {
  const { history, history_images: historyImages, trophies } = kotokoTrophies;
  const { title, trophy_history: trophyHistory } = history;
  const { domestic: domesticTrophies, international: internationalTrophies } =
    trophies;

  const tophyGallery = historyImages.map(function (item, index) {
    return item.image;
  });

  const url = TROPHIES_URL;

  return (
    <>
      {customStaticSeoConfig("Asante Kotoko Trophies")}

      <NoTextNavBackground />

      {domesticTrophies === 0 && (
        <>
          <TabNoData />
        </>
      )}

      {domesticTrophies.length !== 0 && (
        <>
          <HeroSlider
            gallery={tophyGallery}
            title="Trophy Room"
            showScrollToRead={true}
          />

          <MarkdownRender
            title={"Asante Kotoko Trophy Room"}
            caption={
              "Read more about Asante Kotoko's major silverware triumphs."
            }
            url={url}
            markdownData={trophyHistory}
          />

          <div className="mt-2 max-w-2xl mx-auto lg:max-w-7xl lg:px-8 px-6">
            {domesticTrophies.length !== 0 && (
              <div className="pb-16">
                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  Domestic
                </h2>

                <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
                  {domesticTrophies.map((trophy) => (
                    <div key={trophy.name} className="group relative">
                      <TrophyDataCard trophy={trophy} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {internationalTrophies.length !== 0 && (
              <div className="pb-16">
                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2">
                  International
                </h2>

                <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
                  {internationalTrophies.map((trophy) => (
                    <div key={trophy.name} className="group relative">
                      <TrophyDataCard trophy={trophy} />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Trophies;

export const getStaticProps = async (context) => {
  const token = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const kotokoTrophies = await apiWrapper.get(kClubTrophiesURL, token);

  return {
    props: {
      kotokoTrophies: kotokoTrophies?.data,
    },
    revalidate: ONE_MONTH_REFRESH_INTERVAL_SECONDS,
  };
};
